import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';
import { PiniaVuePlugin, createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import vuejsDialog from './plugins/vuejsDialog';
import VueMask from './plugins/vueMask';

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(pinia);

Vue.config.productionTip = false;
// eslint-disable-next-line import/prefer-default-export
export const bus = new Vue(); // Le bus doit être exporté, sinon les autres fichiers n'y ont pas accès

const moment = require('moment');
require('moment/locale/fr-ca');
require('moment/locale/en-ca');

moment.locale(i18n.locale);
Vue.use(require('vue-moment'), {
  moment,
});

Vue.directive('mask', VueMaskDirective);

new Vue({
  router,
  vuetify,
  i18n,
  vuejsDialog,
  VueMask,
  pinia,
  render: (h) => h(App),
}).$mount('#app');
